import { apiClient } from '@/services/'
export const namespaced = true

export const state = {
  loadingPreferences: false,
  dashboardLinks: [],
  preferencesEdited: false,
  saveError: false,
  activeCards: [],
}

export const mutations = {
  SET_DASHBOARD_LINKS(state, status) {
    state.dashboardLinks = status
  },
  SET_LOADING_PREF(state, status) {
    state.loadingPreferences = status
  },
  SET_SAVE_ERROR(state, status) {
    state.saveError = status
  },
  SET_EDITED_PREF(state, status) {
    state.preferencesEdited = status
  },
  SET_ACTIVE_CARDS(state, status) {
    state.activeCards = status
  },
}

export const actions = {
  fetchDashboardPreferences({ dispatch, rootState, commit }) {
    // Loading
    commit('SET_LOADING_PREF', true)
    // Get Preferences
    apiClient
      .get('/GetPreferencesCV', {
        params: {
          sAdName: rootState.adName,
        },
      })
      .then((response) => {
        if (response.data.errorType == 'Error') {
          commit('SET_LOADING_PREF', false)
        } else {
          // Check if preferences have been previously saved, otherwise return full list as active
          const flag = response.data.preferences.length > 0
          if (flag) {
            dispatch('setDashboardPreferences', response.data.preferences)
          } else {
            commit('SET_DASHBOARD_LINKS', rootState.dashboard.linksDefaults)
            commit(
              'SET_ACTIVE_CARDS',
              state.dashboardLinks.filter((s) => s.active == 'Y')
            )
            commit('SET_LOADING_PREF', false)
          }
          rootState.userInfo.userRole.push(7)
        }
      })
  },
  updateDashboardPreferences({ rootState, commit }, updatedPrefs) {
    commit('SET_LOADING_PREF', true)
    // Prep data for saving
    const formattedData = {
      bSetPrefsFlag: true,
      preferences: updatedPrefs.map((x) => {
        return {
          studPortalPrefsId: x.studPortalPrefsId > 0 ? x.studPortalPrefsId : 0,
          active: x.active.toString(),
          title: x.title,
        }
      }),
    }
    // Push data to server
    return apiClient
      .post('/SavePreferencesCV', formattedData, {
        params: {
          sAdName: rootState.adName,
        },
      })
      .then((response) => {
        if (response?.status == 200) {
          commit('SET_SAVE_ERROR', false)
          commit('SET_EDITED_PREF', false)
          commit(
            'SET_ACTIVE_CARDS',
            state.dashboardLinks.filter((s) => s.active == 'Y')
          )
        } else {
          commit('SET_SAVE_ERROR', true)
          commit('SET_EDITED_PREF', true)
        }
      })
      .finally(() => {
        commit('SET_LOADING_PREF', false)
      })
  },
  setDashboardPreferences({ commit, rootState }, preferences) {
    // Get full list
    const dashboardLinks = rootState.dashboard.linksDefaults,
      inactiveCards = preferences
        .filter((s) => s.active.includes('N'))
        .map((e) => {
          return e.title
        })
    // Update active status
    dashboardLinks.forEach((listItem) => {
      const inactive = inactiveCards.find((title) => title == listItem.title)
      if (inactive) listItem.active = 'N'
      else listItem.active = 'Y'
    })
    // Save dashboard links
    commit('SET_DASHBOARD_LINKS', dashboardLinks)
    commit(
      'SET_ACTIVE_CARDS',
      state.dashboardLinks.filter((s) => s.active == 'Y')
    )
    commit('SET_LOADING_PREF', false)
  },
}
